<div class="common-bg h-12 " style="background: #11478b;">

    <div class="flex h-full justify-between w-full" style="align-items: center;">
        <div class="ml-3">
            <div class="font-medium text-2xl text-white" style="align-items: center;margin-left: 10px;font-size: 14px !important;">
                Payment Details
            </div>
        </div>

        <div class="">
            <button mat-button (click)="cancleDcVwr()" style="    float: right;">
                <mat-icon  class="text-white" >close</mat-icon>
            </button>
        </div>
    </div>
</div>
<div id="outerContainer" class="w-full">

    <div  id="dv_pymnt_ldr">
        <div class="pymnt-dtls-ldr" >Fetching your payment details. Please wait.....</div>

        <table class="tg">

            <tr>
                <td class="tg-cly1">
               
              </td>
              <td class="tg-cly1">
              </td>
              <td class="tg-cly1">
                <div class="line"></div>
              </td>
              <td class="tg-cly1">
                <div class="line"></div>
              </td>
            </tr>
            
             <tr>
              <td class="tg-cly1">
                <div class="line"></div>
              </td>
              <td class="tg-cly1">
                <div class="line"></div>
              </td>
            </tr>
             <tr>
              <td class="tg-cly1">
                <div class="line"></div>
              </td>
              <td class="tg-cly1">
                <div class="line"></div>
              </td>
            </tr>
             <tr>
              <td class="tg-cly1">
                <div class="line"></div>
              </td>
              <td class="tg-cly1">
                <div class="line"></div>
              </td>
            </tr>
             <tr>
              <td class="tg-cly1">
                <div class="line"></div>
              </td>
              <td class="tg-cly1">
                <div class="line"></div>
              </td>
                 <td class="tg-cly1">
                <div class="line"></div>
              </td>
                <td class="tg-cly1">
                <div class="line"></div>
              </td>
            </tr>
              <tr>
                <td class="tg-cly1">
               
              </td>
              <td class="tg-cly1">
              </td>
              <td class="tg-cly1">
              </td>
              <td class="tg-cly1">
                <div class="line"></div>
              </td>
            </tr>
            
          </table>
    </div>


    <div *ngIf="data.orderDetails && data.orderDetails.length > 0" class="w-full">
        <div class="bg-white   flex flex-col mt-2 p-4" style=" padding-left: 60px !important;
        align-items: center;
        padding-right: 60px !important;
        background: rgb(232 234 246 / 57%) !important;
        margin: 20px !important;">
            <!-- <h2 class="font-semibold mb-4 text-2xl text-center w-full">Order Details</h2> -->
            <div class="flex my-2 w-full prfDtl">
                <div class="flex flex-col w-2/4">
                    <h1  class="justify-start"  style="font-size: 18px;text-transform: capitalize;">{{data.result.bnfcry_name }}</h1>
                    <p  class="justify-start flex" ><img src="../../../../assets/images/home/phn.png" style="margin-right: 6px;
                        width: 18px;
                        height: 16px;
                        margin-top: 1px;">{{ data.result.contact }}</p>
                    <p  class="justify-start flex" ><img src="../../../../assets/images/home/adr.png" style="margin-right: 6px;">{{ data.result.aadhaar }}</p>
                </div>
                <div class="flex flex-col w-1/4">
                    <h1 class="justify-end" style="color: rebeccapurple;"><b>Ref:</b> #{{data.result.trnsn_rfrnc_nu}}</h1>
                    <p class="justify-end" ><b>Date:</b> {{ today | date: 'dd MMM, yyyy' }}</p>
                </div>
            </div>

            <div class="flex flex-col mb-3 w-full">
                <div class="flex mb-2" style="font-size: 13px;
                font-weight: 600 !important;
                color: #1b59a7;padding-left: 6px;">
                    Amount Details :
                </div>
                <div class="grid grid-cols-12 mx-1">
                    <div class="col-span-12 flex justify-between py-1 px-2 bg-gray-300 " style="    font-size: 12px;">
                        <div class="flex w-4/5">
                            <div class="col-span-2 text-center font-medium">
                                S.no
                            </div>
                            <div class="col-span-6 font-medium  pl-10 text-center">
                                Payment Name
                            </div>
                        </div>
                        <div class="col-span-4 text-center font-medium">
                            Amount
                        </div>
                    </div>

                    <div class="col-span-12 flex justify-between py-1 px-2" style="background: #fff;font-size: 13px;">
                        <div class="flex w-4/5">
                            <div class="col-span-2 font-semibold ml-3 text-center">
                                1
                            </div>
                            <div class="col-span-6 font-semibold ml-12 text-center" *ngIf="data.result.emi_mnth && data.result.emi_mnth != null">
                                {{data.result.emi_mnth}}
                            </div>

                            <div class="col-span-6 font-semibold ml-12 text-center" *ngIf="data.result.emi_mnth == null && DialogData.paymnet_hdr_name == 'ben_contr_pmnt'">
                             Beneficiary Contribution
                          </div>
                        </div>
                        <div class="col-span-4 text-center font-semibold">
                            {{ data.result.amount | currency:'INR':'symbol' }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex justify-between px-3" style="align-self: self-end;font-size: 13px;color: rebeccapurple;">
                <div class="font-medium">
                    Total :
                </div>
                <div class="font-semibold ml-2">
                    {{ data.result.amount | currency:'INR':'symbol' }}
                </div>
            </div>

            <div class="flex justify-center mt-6 space-x-4">
              <button mat-stroked-button class="cnclBtn" (click)="onPayentCancel()">Cancel</button>
              <button mat-raised-button color="primary" 
                    (click)="sbmtPay()" 
                    [disabled]="paymentInProgress"
                    style="background-color: #11478b !important;color: #fff !important;width: 100%;height: 40px;">
                Proceed to Pay
            </button>
            </div>
        </div>

      
    </div>


</div>